import styled from "styled-components";

export const StyledMain = styled.main`
  display: flex;
  min-height: 100vh;
  position: relative;

  @media (max-width: 1100px) {
    flex-direction: column;
  }
`;
